interface IItem {
    quantity: number;
    quantityReturns: number;
    quantitySecond: number;
    quantitySecondReturns: number;
    // order-only third unit (no conversion); display/label only, never charged
    quantityThird?: number;
    id: number;
    external_id?: string;
    ent?:any;
    ent_bname?:string;
    driver?:string
    agent?:string
    ent_name?:number;
    barcode: string;
    position: number;
    no_tax_product: boolean;
    unit: string;
    in_unit?: number;
    available_units: string[];
    name: string;
    image: string;
    category: string;
    category2: string;
    conversion_ratio: number;
    totalPrice: number;
    totalPriceInclude?: number;
    totalPriceExclude?: number;
    discount: number;
    weight?:number;
    volume?:number
    notes?:string;
    notes2?:string;
    notes3?:string;
    forceShow?:boolean,
    notePlacement?:number
    nkObject: any;
    costPrice?: number;
    /** Fixed Product.cost_price — מחיר עלות קבוע (not dated client_prices). */
    fixedCostPrice?: number;
    available?:number
    priority?:number
    unit_preferece?: number
    isLocked?:boolean
    priceTouched?: boolean;
    // Explicit flag for whether the product has a genuine (charged, converted) second unit
    // configured - set by the IItem builders that have direct access to the OrderProduct
    // (itemApiIInternal in products_prices.api.ts / DocumentsTypes/utils.ts). Some callers
    // (e.g. the order drawer) repurpose `nkObject` to point at the order rather than the
    // product, which makes it impossible to resolve this via nkObject alone - so prefer this
    // flag when present instead of guessing from nkObject's shape.
    hasSecondUnitName?: boolean;

}

/** available_units: [first], [first, second], [first, third], or [first, second, third] */
export function secondUnitIndex(row: IItem): number {
    if (row.available_units.length < 2) return -1;
    if (row.available_units.length >= 3) return 1;
    if (row.hasSecondUnitName != null) return row.hasSecondUnitName ? 1 : -1;
    // nkObject shape differs by source: ProductDelivery exposes getProduct(), while the
    // customer price-list rows (products_prices.api.ts) expose a plain `.product` property.
    const product = row.nkObject?.getProduct?.() ?? row.nkObject?.product;
    const unit2 = product?.getOrderProduct?.()?.getExtraUnitName?.();
    return unit2 != null && unit2 !== '' ? 1 : -1;
}

export function thirdUnitIndex(row: IItem): number {
    if (row.available_units.length >= 3) return 2;
    if (row.available_units.length === 2 && secondUnitIndex(row) < 0) return 1;
    return -1;
}

export function hasSecondUnit(row: IItem): boolean {
    return secondUnitIndex(row) >= 0;
}

export function hasThirdUnit(row: IItem): boolean {
    return thirdUnitIndex(row) >= 0;
}

/** Leftover wrapped_amount after the catalog second unit was removed. */
export function hasStoredSecondAmount(row: IItem): boolean {
    return (row.quantitySecond ?? 0) !== 0 || (row.quantitySecondReturns ?? 0) !== 0;
}

/** Show the תיאור column for a catalog extra unit or a leftover stored second/third amount. */
export function showsWrappedColumn(row: IItem): boolean {
    return hasSecondUnit(row) || hasThirdUnit(row) || (row.quantityThird ?? 0) !== 0 || hasStoredSecondAmount(row);
}

export function wrappedNetSecond(row: IItem): number {
    return row.quantitySecond - (row.quantitySecondReturns ?? 0);
}

/** Read-only תיאור column: second-unit net line, then third-unit line (mirrors Android wrappedColumnText). */
export function wrappedColumnDisplay(row: IItem, lineSeparator = '\n'): string {
    const lines: string[] = [];
    const secondIdx = secondUnitIndex(row);
    const netSecond = wrappedNetSecond(row);
    if (netSecond !== 0) {
        const unitLabel = secondIdx >= 0 ? row.available_units[secondIdx] : '';
        lines.push(unitLabel ? `${netSecond} ${unitLabel}` : String(netSecond));
    }
    const thirdIdx = thirdUnitIndex(row);
    const thirdQty = row.quantityThird ?? 0;
    if (thirdQty !== 0) {
        const unitLabel = thirdIdx >= 0 ? row.available_units[thirdIdx] : '';
        lines.push(unitLabel ? `${thirdQty} ${unitLabel}` : String(thirdQty));
    }
    return lines.join(lineSeparator);
}

/** Order comparison column: wrapped amounts when present, else first-unit quantity. */
export function orderColumnDisplay(row: IItem): string {
    const wrapped = wrappedColumnDisplay(row).trim();
    return wrapped || String(row.quantity ?? 0);
}

export default IItem;
